import { render, staticRenderFns } from "./RefLogin.vue?vue&type=template&id=db06bf00&scoped=true&"
import script from "./RefLogin.vue?vue&type=script&lang=js&"
export * from "./RefLogin.vue?vue&type=script&lang=js&"
import style0 from "./RefLogin.vue?vue&type=style&index=0&id=db06bf00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db06bf00",
  null
  
)

export default component.exports